import { render, staticRenderFns } from "./extras-overview.vue?vue&type=template&id=4b7b88c4&"
import script from "./extras-overview.vue?vue&type=script&lang=js&"
export * from "./extras-overview.vue?vue&type=script&lang=js&"
import style0 from "./extras-overview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports